import { render, staticRenderFns } from "./FileEditorSettings.vue?vue&type=template&id=20345030&"
import script from "./FileEditorSettings.vue?vue&type=script&lang=ts&"
export * from "./FileEditorSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports